// extracted by css-extract-rspack-plugin
export default {"spaceLarge":"32px","size300":"300px","viewRoot":"byod-dashboard-view__viewRoot___kArYN","statusContainer":"byod-dashboard-view__statusContainer___VyP9W"};